import React, { useContext, useState, Fragment } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  TextField,
} from "@mui/material";
import Tools from "./JNSTools";
import { CredsContext } from "./Contexts";
import { grey } from "@mui/material/colors";

import "./styles/Settings.css";

function SettingsGanttChart(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const loadedSettings = JSON.parse(localStorage.getItem("oadaSettings"));
  const [enableBookings, setEnableBookings] = useState(false);

  const [resourceBasis, setResourceBasis] = useState({
    source: loadedSettings ? loadedSettings.ganttSource : "Booking",
    dateSource: loadedSettings ? loadedSettings.ganttDateSource : "bookings",
  });

  const [allowDateEditing, setAllowDateEditing] = useState(
    loadedSettings
      ? loadedSettings.ganttDateEditing == "true" ||
          loadedSettings.ganttDateEditing == true
      : false,
  );
  const [showAllocationPercentages, setShowAllocationPercentages] = useState(
    loadedSettings
      ? loadedSettings.showAllocationPercentages == "true" ||
          loadedSettings.showAllocationPercentages == true
      : false,
  );
  const [thresholds, setThresholds] = useState(
    loadedSettings
      ? loadedSettings.thresholds
        ? loadedSettings.thresholds
        : { t1: 10, t2: 20 }
      : { t1: 10, t2: 20 },
  );

  let threshold1;
  let threshold2;

  const handleSourceClick = (event) => {
    const currentSettings = JSON.parse(localStorage.getItem("oadaSettings"));
    let newSettings;
    if (event.target.value == "Booking") {
      newSettings = {
        ...currentSettings,
        ganttSource: event.target.value,
        ganttDateSource: "bookings",
      };
      localStorage.setItem("oadaSettings", JSON.stringify(newSettings));
      Tools.writeSettings(creds, projectObject.id);
      setResourceBasis({ source: event.target.value, dateSource: "bookings" });
    } else if (event.target.value == "Projecttaskassign") {
      newSettings = {
        ...currentSettings,
        ganttSource: event.target.value,
        ganttDateSource: "tasks",
      };
      localStorage.setItem("oadaSettings", JSON.stringify(newSettings));
      Tools.writeSettings(creds, projectObject.id);
      setResourceBasis({ source: event.target.value, dateSource: "tasks" });
    }
  };

  const handleDateSourceClick = (event) => {
    const currentSettings = JSON.parse(localStorage.getItem("oadaSettings"));
    const newSettings = {
      ...currentSettings,
      ganttDateSource: event.target.value,
    };
    localStorage.setItem("oadaSettings", JSON.stringify(newSettings));
    Tools.writeSettings(creds, projectObject.id);
    setResourceBasis({ ...resourceBasis, dateSource: event.target.value });
  };

  const handleDateEditingClick = () => {
    const currentSettings = JSON.parse(localStorage.getItem("oadaSettings"));
    const newSettings = {
      ...currentSettings,
      ganttDateEditing: !allowDateEditing,
    };
    localStorage.setItem("oadaSettings", JSON.stringify(newSettings));
    Tools.writeSettings(creds, projectObject.id);
    setAllowDateEditing(!allowDateEditing);
  };

  const handleAllocationPercentagesClick = () => {
    const currentSettings = JSON.parse(localStorage.getItem("oadaSettings"));
    const newSettings = {
      ...currentSettings,
      showAllocationPercentages: !showAllocationPercentages,
    };
    localStorage.setItem("oadaSettings", JSON.stringify(newSettings));
    Tools.writeSettings(creds, projectObject.id);
    setShowAllocationPercentages(!showAllocationPercentages);
  };

  const handleThresholdChange = () => {
    const currentSettings = JSON.parse(localStorage.getItem("oadaSettings"));
    const newSettings = {
      ...currentSettings,
      thresholds: {
        t1: threshold1.childNodes[0].childNodes[0].value,
        t2: threshold2.childNodes[0].childNodes[0].value,
      },
    };
    localStorage.setItem("oadaSettings", JSON.stringify(newSettings));
    Tools.writeSettings(creds, projectObject.id);
    setThresholds({ t1: threshold1.value, t2: threshold2.value });
  };

  const bookingByTask = sessionStorage.getItem("bookingByTask");
  const resourceBasisText =
    bookingByTask == "false"
      ? "Booking by tasks is not enabled in the current SuiteProjects Pro instance"
      : "Choose the source of resource allocations on tasks";

  return (
    <Box>
      <FormControl>
        <FormLabel>
          <div
            className="settingsGroupTitle"
            style={{ verticalAlign: "middle" }}
          >
            Resource basis
          </div>
          <div
            className="settingsDescriptiveText"
            style={{ marginLeft: "20px" }}
          >
            {resourceBasisText}
          </div>
        </FormLabel>
        <RadioGroup name="radio-buttons-group">
          <FormControlLabel
            value="Booking"
            checked={resourceBasis.source == "Booking"}
            disabled={bookingByTask == "false"}
            onClick={handleSourceClick}
            control={
              <Radio
                size="small"
                sx={{
                  marginLeft: "20px",
                  color: grey[50],
                  "&.Mui-checked": {
                    color: grey[50],
                  },
                }}
              />
            }
            label="Bookings"
            className="settingsRadioButtonLabel"
          />
          <FormControlLabel
            value="Projecttaskassign"
            checked={resourceBasis.source == "Projecttaskassign"}
            onClick={handleSourceClick}
            control={
              <Radio
                size="small"
                sx={{
                  marginLeft: "20px",
                  color: grey[50], //closest thing to white available
                  "&.Mui-checked": {
                    color: grey[50],
                  },
                }}
              />
            }
            label="Task Assignments"
            className="settingsRadioButtonLabel"
          />
        </RadioGroup>
        <Box>
          <br></br>
          <br></br>
        </Box>
        <Fragment>
          <FormLabel>
            <div className="settingsGroupTitle">Task dates</div>
            <div
              className="settingsDescriptiveText"
              style={{ marginLeft: "20px" }}
            >
              Choose how to identify the start and end dates of tasks
            </div>
          </FormLabel>
          <RadioGroup>
            <FormControlLabel
              value="bookings"
              checked={resourceBasis.dateSource == "bookings"}
              disabled={resourceBasis.source == "Projecttaskassign"}
              onClick={handleDateSourceClick}
              control={
                <Radio
                  size="small"
                  sx={{
                    marginLeft: "20px",
                    color: grey[50],
                    "&.Mui-checked": {
                      color: grey[50],
                    },
                  }}
                />
              }
              label="Earliest and latest booked dates"
              className="settingsRadioButtonLabel"
            />
            <FormControlLabel
              value="tasks"
              checked={resourceBasis.dateSource == "tasks"}
              onClick={handleDateSourceClick}
              control={
                <Radio
                  size="small"
                  sx={{
                    marginLeft: "20px",
                    color: grey[50], //closest thing to white available
                    "&.Mui-checked": {
                      color: grey[50],
                    },
                  }}
                />
              }
              label="Task start and end dates"
              className="settingsRadioButtonLabel"
            />
          </RadioGroup>
        </Fragment>
        <Box>
          <br></br>
          <br></br>
        </Box>
        <FormLabel>
          <div className="settingsGroupTitle">Analysis Thresholds</div>
          <div
            className="settingsDescriptiveText"
            style={{ marginLeft: "20px" }}
          >
            Set the points where the analysis identifies a percent difference as
            Slight, Moderate, or Severe
          </div>
        </FormLabel>
        <br></br>
        <Box sx={{ marginLeft: "20px" }}>
          <span
            className="settingsRadioButtonLabel"
            style={{ verticalAlign: "middle" }}
          >
            Slight to Moderate breakpoint:
          </span>
          <TextField
            ref={(t) => (threshold1 = t)}
            onChange={handleThresholdChange}
            value={thresholds.t1}
            variant="filled"
            size="small"
            placeholder="10"
            inputProps={{ style: { padding: "2px", textAlign: "center" } }}
            sx={{
              margin: "0px 2px 0px 20px",
              width: "75px",
              backgroundColor: "white",
              color: "black",
              borderRadius: "15px",
              fontSize: "large",
            }}
          />
          <span className="settingsRadioButtonLabel">&nbsp;%</span>
        </Box>
        <br></br>
        <Box sx={{ marginLeft: "20px" }}>
          <span
            className="settingsRadioButtonLabel"
            style={{ verticalAlign: "middle" }}
          >
            Moderate to Severe breakpoint:
          </span>
          <TextField
            ref={(t) => (threshold2 = t)}
            onChange={handleThresholdChange}
            value={thresholds.t2}
            variant="filled"
            size="small"
            placeholder="20"
            inputProps={{ style: { padding: "2px", textAlign: "center" } }}
            sx={{
              margin: "0px 2px 0px 13px",
              width: "75px",
              backgroundColor: "white",
              color: "black",
              borderRadius: "15px",
              fontSize: "large",
            }}
          />
          <span className="settingsRadioButtonLabel">&nbsp;%</span>
        </Box>
      </FormControl>
      <br></br>
      <br></br>

      <FormLabel>
        <div className="settingsGroupTitle">Taskbar Settings</div>
      </FormLabel>
      <FormControlLabel
        checked={showAllocationPercentages}
        onClick={handleAllocationPercentagesClick}
        control={
          <Checkbox
            size="small"
            sx={{
              marginLeft: "20px",
              color: grey[50],
              "&.Mui-checked": {
                color: grey[50],
              },
            }}
          />
        }
        label="Show resource allocation percentages on taskbars"
        className="settingsRadioButtonLabel"
      />
      <br></br>
      <br></br>

      <FormLabel>
        <div className="settingsGroupTitle">Date Editing</div>
      </FormLabel>
      <FormControlLabel
        checked={allowDateEditing}
        onClick={handleDateEditingClick}
        control={
          <Checkbox
            size="small"
            sx={{
              marginLeft: "20px",
              color: grey[50],
              "&.Mui-checked": {
                color: grey[50],
              },
            }}
          />
        }
        label="Allow date editing in Gantt chart"
        className="settingsRadioButtonLabel"
      />
      <Typography className="settingsWarningText" sx={{ marginLeft: "20px" }}>
        Warning: enabling this option can convert calculated dates to fixed
        dates
      </Typography>
    </Box>
  );
}

export default SettingsGanttChart;

SettingsGanttChart.propTypes = {
  handleSettingsChange: PropTypes.func,
};
